import { useNavigate } from "react-router-dom";

import { ChangePasswordForm } from "@/components/change-password-form";
import { Card } from "@/components/ui/card";
import { Page, PageHeader } from "@/components/ui/page";
import { useTranslation } from "@/store/locale";

/**
 * Changing a password because you decided to, from the account menu or your
 * own profile.
 *
 * Inside the shell, like every other page you choose to open: the sidebar is
 * still there, so it is not a wall and needs no way out of its own. The
 * full-screen `/change-password` stays for the times something else decided —
 * a forced change, an expiry — where the whole point is that there is nothing
 * else to do first.
 */
function ProfilePasswordPage() {
  const t = useTranslation();
  const navigate = useNavigate();

  return (
    <Page>
      {/* One column down the middle: a single form has nothing to sit beside,
          and left-aligning it against a full-width page only strands it. */}
      <div className="mx-auto w-full max-w-xl">
        <PageHeader title={t("page.changePassword")} description={t("pw.subtitle")} />
        <Card className="p-6">
          <ChangePasswordForm size="lg" onDone={() => void navigate("/profile")} />
        </Card>
      </div>
    </Page>
  );
}

export default ProfilePasswordPage;
